import { Person } from "@mui/icons-material";
import { Button, MessageDialog } from "@aderant/aderant-react-components";
import { Header } from "components/Header/Header";
import SettingsMenu from "components/SettingsMenu/SettingsMenu";
import React from "react";
import { HeaderMobile } from "components/Header/HeaderMobile";
import { useLocation } from "react-router";
import { PathMap } from "utilities/routingPathMap";
import { useSelector } from "react-redux";
import { getCurrentUserHasRole } from "state/selectors";
import { UserRole } from "aderant-conflicts-models";
import { useDeviceInfo } from "hooks/useDeviceInfo";

const messages = {
    signOut: "Sign Out"
};

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export default function Page(props: React.ComponentPropsWithRef<any>): JSX.Element {
    const [showDeleteListDialog, setShowDeleteListDialog] = React.useState(props?.isLDSettingErrorVisible);

    const location = useLocation();
    const isResultsPage = location.pathname.includes(PathMap.results);

    const { isMobile } = useDeviceInfo();
    const hasReviewerRole = useSelector(getCurrentUserHasRole(UserRole.Reviewer));

    return (
        <div className="page">
            {isMobile && isResultsPage && hasReviewerRole ? (
                <div>
                    <HeaderMobile />
                </div>
            ) : (
                <div>
                    <Header onSignOut={props.onSignOut} />
                    <div style={{ alignSelf: "center", display: "none", flexDirection: "row" }}>
                        <Button iconButton onClick={props.onSignOut} title={messages.signOut} startIcon={<Person />} aria-label="Log out" />
                        <SettingsMenu />
                    </div>
                </div>
            )}

            {props?.isLDSettingErrorVisible && (
                <MessageDialog
                    open={showDeleteListDialog}
                    onClose={() => setShowDeleteListDialog(false)}
                    message="An error has occurred, causing recently-added features to be disabled. The rest of the application is still available for use."
                    title="Error"
                    footer={
                        <>
                            <Button
                                text="Close"
                                color="secondary"
                                onClick={() => {
                                    setShowDeleteListDialog(false);
                                }}
                            />
                        </>
                    }
                />
            )}
            {props.children}
        </div>
    );
}